import axios from '@/libs/axios'

export const getLayouts = () => {
    return axios.get('/dynamic-import/layouts')
}

export const getLayout = (id) => {
    return axios.get(`/dynamic-import/layouts/${id}`)
}

export const saveLayout = (data) => {
    return axios.post('/dynamic-import/layouts', data)
}

export const deleteLayout = (id) => {
    return axios.delete(`/dynamic-import/layouts/${id}`)
}

export const duplicateLayout = (id) => {
    return axios.post(`/dynamic-import/layouts/${id}/duplicate`)
}

export const extractFile = (file, layoutId) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('layoutId', layoutId)
    return axios.post('/dynamic-import/extract', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getBatchStatus = (batchId) => {
    return axios.get(`/dynamic-import/batch/${batchId}`)
}

export const getBatchItems = (batchId) => {
    return axios.get(`/dynamic-import/items/${batchId}`)
}

export const validateBatch = (batchId) => {
    return axios.post(`/dynamic-import/validate/${batchId}`)
}

export const processBatch = (batchId) => {
    return axios.post(`/dynamic-import/process/${batchId}`)
}
